import React, { useState } from 'react';
import { Header } from '../components/layout/Header';
import { Sidebar } from '../components/layout/Sidebar';
import { PortfolioAccountOverview } from '../components/portfolio/PortfolioAccountOverview';
import { AccountDetailsPanel } from '../components/portfolio/AccountDetailsPanel';
import { PortfolioChart } from '../components/portfolio/PortfolioChart';
import { BalancesSection } from '../components/portfolio/BalancesSection';
import { TransactionsSection } from '../components/portfolio/TransactionsSection';
type AccountType = 'overview' | 'main' | 'futures' | 'earn';
export function PortfolioPage() {
  const [activeAccount, setActiveAccount] = useState<AccountType>('overview');
  return <div className="flex h-screen bg-background-primary text-text-primary overflow-hidden font-sans" data-id="element-1871">
      <Sidebar data-id="element-1872" />

      <div className="flex-1 flex flex-col min-w-0" data-id="element-1873">
        <Header data-id="element-1874" />

        <main className="flex-1 overflow-y-auto p-4 md:p-6 space-y-4 md:space-y-6" data-id="element-1875">
          {/* Account Navigation Tabs */}
          <div className="flex items-center gap-2 overflow-x-auto pb-2" data-id="element-1876">
            <button onClick={() => setActiveAccount('overview')} className={`px-4 py-2 text-sm font-medium rounded-full transition-all whitespace-nowrap ${activeAccount === 'overview' ? 'bg-brand-purple text-white' : 'text-text-secondary hover:text-text-primary hover:bg-background-elevated'}`} data-id="element-1877">
              Overview
            </button>
            <button onClick={() => setActiveAccount('main')} className={`px-4 py-2 text-sm font-medium rounded-full transition-all whitespace-nowrap ${activeAccount === 'main' ? 'bg-brand-purple text-white' : 'text-text-secondary hover:text-text-primary hover:bg-background-elevated'}`} data-id="element-1878">
              Main
            </button>
            <button onClick={() => setActiveAccount('futures')} className={`px-4 py-2 text-sm font-medium rounded-full transition-all whitespace-nowrap ${activeAccount === 'futures' ? 'bg-brand-purple text-white' : 'text-text-secondary hover:text-text-primary hover:bg-background-elevated'}`} data-id="element-1879">
              Futures
            </button>
            <button onClick={() => setActiveAccount('earn')} className={`px-4 py-2 text-sm font-medium rounded-full transition-all whitespace-nowrap ${activeAccount === 'earn' ? 'bg-brand-purple text-white' : 'text-text-secondary hover:text-text-primary hover:bg-background-elevated'}`} data-id="element-1880">
              Earn
            </button>
          </div>

          {/* Account Content */}
          {activeAccount === 'overview' && <PortfolioAccountOverview data-id="element-1881" />}

          {activeAccount !== 'overview' && <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-6" data-id="element-1882">
              {/* Left: Chart and Content */}
              <div className="space-y-6" data-id="element-1883">
                <PortfolioChart accountType={activeAccount} data-id="element-1884" />
                <BalancesSection accountType={activeAccount} data-id="element-1885" />
                <TransactionsSection accountType={activeAccount} data-id="element-1886" />
              </div>

              {/* Right: Account Details Panel */}
              <AccountDetailsPanel accountType={activeAccount} data-id="element-1887" />
            </div>}
        </main>
      </div>
    </div>;
}